import React from "react";

import { BundleGroupTypes } from "../../../constants";
import { ICompareTile } from "../../../models/product-compare";
import { setSelectedUpgrade } from "../../configurator/reducers";
import {
    baseVariantSelector,
    rootProductSelector,
    upgradeBundlesSelector,
} from "../../configurator/selectors";
import { useAppDispatch, useAppSelector } from "../../reducers";
import { IRootState } from "../../reducers.interfaces";
import { defaults } from "../defaults";
import { ProductCompareUpgradeTile as ProductCompareUpgradeTileComponent } from "../elements/ProductCompareUpgradeTile";

export const ProductCompareUpgradeTile = (props: {
    tile: ICompareTile;
}): React.ReactNode => {
    const dispatch = useAppDispatch();

    const state = useAppSelector(
        (rootState: IRootState) => rootState.configurator || defaults,
    );
    const rootProduct = useAppSelector((rootState: IRootState) =>
        rootProductSelector(rootState.configurator),
    );
    const baseVariant = baseVariantSelector(state);
    const pageRootProduct = rootProduct ? rootProduct.id : null;
    const selectedUpgrade = state.ui.selectedUpgrade;
    const upgradeBundles = upgradeBundlesSelector(
        state.entities.concreteBundles,
        baseVariant,
        BundleGroupTypes.UPGRADE_PRODUCT,
    );

    const isSelected = selectedUpgrade ? true : false;

    return (
        <ProductCompareUpgradeTileComponent
            product={props.tile.rootProducts[0]}
            selectedUpgrades={
                selectedUpgrade
                    ? [
                          {
                              productID: selectedUpgrade,
                              quantity: 1,
                          },
                      ]
                    : []
            }
            isSelected={isSelected}
            pageRootProduct={pageRootProduct}
            onSelectionChange={(updates) => {
                if (updates.length > 0) {
                    const update = updates[0];
                    dispatch(
                        setSelectedUpgrade(
                            update.quantity > 0 ? update.productID : null,
                        ),
                    );
                }
            }}
            upgradeBundles={upgradeBundles}
        />
    );
};
